import React from 'react'

import { InnerWrapper, StyledImage, Wrapper } from './FileContents.styles'
import { NoContent } from './NoContent'

interface ImageViewerProps {
  fileExtension: string
  signedUrl?: string
}

export const ImageViewer = ({ fileExtension, signedUrl }: ImageViewerProps) => {
  if (!signedUrl) return <NoContent />

  return (
    <Wrapper>
      <InnerWrapper>
        <StyledImage
          alt={`${fileExtension} file preview`}
          data-testid={`${fileExtension}-file-preview`}
          src={signedUrl}
        />
      </InnerWrapper>
    </Wrapper>
  )
}
